export default "__VITE_ASSET__07011da1__"